"use es6";

import { createRenderBatcher } from "./batcher";
const {
  schedule: microtask,
  cancel: cancelMicrotask
} = createRenderBatcher(queueMicrotask, false);
export { cancelMicrotask, microtask };